// extracted by mini-css-extract-plugin
module.exports = {"btnBlue":"settings_btnBlue_2Qivg","btnBlueOutline":"settings_btnBlueOutline_2Ppkh","invalidCoding":"settings_invalidCoding_V6Oa0","tabItem":"settings_tabItem_3IZOt"};